import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import type { ChangeEvent, PropsWithChildren } from 'react';

type TourDuplicateDialogItemProps = PropsWithChildren & {
    label: string;
    checked: boolean;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const TourDuplicateDialogItem = ({ label, checked, onChange, children }: TourDuplicateDialogItemProps) => {
    return (
        <li className='list-group-item'>
            <Checkbox custom checked={checked} onChange={onChange}>
                <div className='checkbox-text-wrapper display-flex justify-content-between align-items-center width-100pct'>
                    <span>{label}</span>
                    <span className='checkbox-text' />
                </div>
            </Checkbox>
            {children}
        </li>
    );
};
